/* tslint:disable */
/* eslint-disable */
/**
 * Warpgate Web Admin
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0.22.0-beta.6-6-gfde9e530-modified
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { KubernetesTargetAuthFromJSON, KubernetesTargetAuthToJSON, } from './KubernetesTargetAuth';
import { TlsFromJSON, TlsToJSON, } from './Tls';
/**
 * @export
 */
export const TargetOptionsTargetKubernetesOptionsKindEnum = {
    Kubernetes: 'Kubernetes'
};
/**
 * Check if a given object implements the TargetOptionsTargetKubernetesOptions interface.
 */
export function instanceOfTargetOptionsTargetKubernetesOptions(value) {
    if (!('clusterUrl' in value) || value['clusterUrl'] === undefined)
        return false;
    if (!('tls' in value) || value['tls'] === undefined)
        return false;
    if (!('auth' in value) || value['auth'] === undefined)
        return false;
    if (!('kind' in value) || value['kind'] === undefined)
        return false;
    return true;
}
export function TargetOptionsTargetKubernetesOptionsFromJSON(json) {
    return TargetOptionsTargetKubernetesOptionsFromJSONTyped(json, false);
}
export function TargetOptionsTargetKubernetesOptionsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'clusterUrl': json['cluster_url'],
        'tls': TlsFromJSON(json['tls']),
        'auth': KubernetesTargetAuthFromJSON(json['auth']),
        'kind': json['kind'],
    };
}
export function TargetOptionsTargetKubernetesOptionsToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'cluster_url': value['clusterUrl'],
        'tls': TlsToJSON(value['tls']),
        'auth': KubernetesTargetAuthToJSON(value['auth']),
        'kind': value['kind'],
    };
}
